/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Helper Functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const cardContent = {
  styleOverrides: {
    root: {
      // ✅ Supprime les marges par défaut
      marginTop: 0,
      marginBottom: 0,

      // ✅ Padding revu pour être plus équilibré
      padding: `${pxToRem(20)} ${pxToRem(24)}`,

      // ✅ Coins arrondis comme pour le thème clair (consistance visuelle)
      borderRadius: pxToRem(16),

      // ✅ Couleur adaptée au fond sombre
      backgroundColor: "#1e1e2f",

      // ✅ Ombre douce pour rester visible sur fond sombre
      boxShadow: "0px 2px 12px rgba(255, 255, 255, 0.04)",

      // ✅ Transition douce pour interactions visuelles
      transition: "all 0.3s ease-in-out",
    },
  },
};

export default cardContent;
